import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Products',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/products/:id/instrument-type',
    name: 'InstrumentType',
    component: () => import('../components/InstrumentType.vue')
  },
  {
    path: '/products/:id/instrument-type/:intrumentype_id/result/',
    name: 'Result',
    component: () => import('../components/Result.vue')
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import('../components/Disclaimer.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router